import { render } from "./EditScoringRecordItemDialog.vue?vue&type=template&id=4e651a6e"
import script from "./EditScoringRecordItemDialog.vue?vue&type=script&lang=js"
export * from "./EditScoringRecordItemDialog.vue?vue&type=script&lang=js"
script.render = render

export default script